const theme = {
  breakpoints: {
    sm: 600,
    md: 768,
    lg: 1024
  }
}

export { theme }
